import { memo } from 'react';
import { StyledButton, StyledCloseIcon } from './style';

const ClearButton = ({ clearText, handleClick, isDisabled }) => (
  <StyledButton isDirty={false} onClick={handleClick} data-testid="select-clear-button" disabled={isDisabled}>
    <StyledCloseIcon />
    {clearText}
  </StyledButton>
);

export default memo(ClearButton);
